import { render, staticRenderFns } from "./CriteriaSelected.vue?vue&type=template&id=da45dd00&scoped=true&"
import script from "./CriteriaSelected.vue?vue&type=script&lang=js&"
export * from "./CriteriaSelected.vue?vue&type=script&lang=js&"
import style0 from "./CriteriaSelected.vue?vue&type=style&index=0&id=da45dd00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da45dd00",
  null
  
)

export default component.exports